import { render, staticRenderFns } from "./VimsEditPerson.vue?vue&type=template&id=c54007f0&"
import script from "./VimsEditPerson.vue?vue&type=script&lang=js&"
export * from "./VimsEditPerson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports